import { render, staticRenderFns } from "./Profitloss.vue?vue&type=template&id=d662e078&scoped=true&"
import script from "./Profitloss.vue?vue&type=script&lang=ts&"
export * from "./Profitloss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d662e078",
  null
  
)

export default component.exports